import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { formatApiErrorDetail } from "@/lib/errors";
import { toast } from "sonner";
import { Ship } from "lucide-react";
import { DealerShipmentCard } from "@/components/dealer/DealerShipmentCard";

export default function DealerShipments() {
  const [data, setData] = useState(null);
  const [tab, setTab] = useState("incoming");

  const load = () => api.get("/dealer/shipments").then((r) => setData(r.data)).catch((e) => toast.error(formatApiErrorDetail(e.response?.data?.detail)));
  useEffect(() => { load(); }, []);

  if (!data) return <div className="p-8 text-sm text-warmgrey" data-testid="shipments-loading">Loading shipments…</div>;
  const list = data[tab];

  return (
    <div data-testid="dealer-shipments-page">
      <p className="font-mono text-xs uppercase tracking-widest text-terracotta">Supply chain</p>
      <h1 className="mt-2 font-display text-4xl font-light tracking-tight text-charcoal sm:text-5xl">Shipments</h1>
      <p className="mt-2 max-w-2xl text-sm text-warmgrey">Journey from the Fez factory to the Zelligio warehouse in West Palm Beach. Dates shown are verified milestones; availability dates are approved by Zelligio. Arrival at Miami port does not make stock available — warehouse receiving does.</p>
      <div className="mt-8 flex gap-6 border-b border-border">
        {[["incoming", `Incoming (${data.incoming.length})`], ["completed", `Completed · last ${data.history_days} days (${data.completed.length})`]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setTab(k)} data-testid={`shipments-tab-${k}`} className={`-mb-px border-b-2 pb-3 text-xs font-semibold uppercase tracking-wider transition-colors ${tab === k ? "border-terracotta text-charcoal" : "border-transparent text-warmgrey hover:text-charcoal"}`}>{l}</button>
        ))}
      </div>
      {list.length === 0 ? (
        <div className="mt-10 flex flex-col items-start gap-3 rounded-md border border-dashed border-limestone bg-white p-8" data-testid="shipments-empty">
          <Ship className="h-5 w-5 text-warmgrey" />
          <p className="text-sm text-charcoal">{tab === "incoming" ? (data.empty_message || "No shipments are currently en route.") : "No shipments were received in this period."}</p>
        </div>
      ) : (
        <div className="mt-8 space-y-6">
          {list.map((s) => <DealerShipmentCard key={s.container_id} shipment={s} onChanged={load} />)}
        </div>
      )}
    </div>
  );
}
